module.exports = __webpack_public_path__ + "resources/ab597deed1f469bb71b3698c18f563b6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsvlevel.png
// module id = 203
// module chunks = 0